import {Controller} from "@hotwired/stimulus"
import Cleave from "cleave.js"

// Connects to data-controller="cleave"
export default class extends Controller {
  static values = {type: String}

  connect() {
    if (this.typeValue === "currency") {
      let cleave = new Cleave(this.element, {
        numeral: true,
        numeralThousandsGroupStyle: "thousand",
        prefix: "€ ",
        signBeforePrefix: true,
        delimiter: ".",
        numeralDecimalMark: ',',
        stripLeadingZeroes: true,
        numeralIntegerScale: 8,
        numericOnly: true,
        numeralPositiveOnly: true
      });
    } else if (this.typeValue === "percentage") {
      let cleave = new Cleave(this.element, {
        numeral: true,
        numeralThousandsGroupStyle: "thousand",
        delimiter: ".",
        numeralDecimalMark: ',',
        stripLeadingZeroes: true,
        numeralIntegerScale: 6,
        numericOnly: true,
        numeralPositiveOnly: false
      });
    } else if (this.typeValue === "date") {
      let cleave = new Cleave(this.element, {
        date: true,
        delimter: '/',
        datePattern: ['d', 'm', 'Y']
      });
    } else {
      let cleave = new Cleave(this.element, {
        numeral: true,
        numeralThousandsGroupStyle: "thousand",
        delimiter: ".",
        numeralDecimalMark: ',',
        stripLeadingZeroes: true,
        numeralIntegerScale: 6,
        numericOnly: true,
        numeralPositiveOnly: true
      });
    }
    this.element.addEventListener('input', this.handleInput.bind(this))
    this.handleInput()
  }

  handleInput() {
    if (this.element.value === "€") {
      this.element.value = ""
    }
  }

  disconnect() {
    this.element.removeEventListener('input', this.handleInput.bind(this))
  }
}
